<template>
  <div class="first-section">
    <div class="content">
      <h1>WHERE TO FIND US</h1>
      <img src="@/assets/linkedln-logo.png" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.first-section {
  width: 100vw;
  height: 100vh;
  display: flex;
  background-image: url("@/assets/contact.jpg");
  background-size: cover;

  align-items: center;
  justify-content: center;

  .content {
    flex-wrap: wrap;
    text-align: center;

    img {
      width: 30px;
    }
  }
}
</style>
